

function contieneUrlTexto(texto) {
    const t = String(texto || "");
    // URLs típicas: http(s)://, www., dominios .com/.net/etc
    const urlRegex = /(https?:\/\/\S+)|(www\.\S+)|([a-z0-9-]+\.(com|net|org|io|co|me|app|dev|ai|edu|gov)(\S*)?)/i;
    return urlRegex.test(t);
}

function contieneTelefono(texto) {
    const t = String(texto || "");
    // Detecta secuencias tipo teléfono (7 a 15 dígitos) permitiendo espacios, guiones, paréntesis y +
    // Ej: +57 315 123 4567, (601) 123-4567, 3151234567
    const phoneRegex = /(?:\+?\d{1,3}[\s-]?)?(?:\(\d{1,4}\)[\s-]?)?\d[\d\s-]{6,14}\d/;
    // Para evitar falsos positivos con precios: exigimos al menos 7 dígitos totales
    const soloDigitos = t.replace(/\D/g, "");
    if (soloDigitos.length < 7) return false;
    return phoneRegex.test(t);
}

function contieneCorreo(texto) {
    const t = String(texto || "");
    // Email básico: usuario@dominio.tld (evita espacios)
    const emailRegex = /[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}/i;
    return emailRegex.test(t);
}

function validarNoContacto({ etiqueta, texto, errores }) {
    if (contieneUrlTexto(texto)) {
        errores.push(`${etiqueta}: no puedes incluir links/URLs`);
    }
    if (contieneTelefono(texto)) {
        errores.push(`${etiqueta}: no puedes incluir números de teléfono`);
    }
    if (contieneCorreo(texto)) {
        errores.push(`${etiqueta}: no puedes incluir correos electrónicos`);
    }
}

function precioValido(precioStr) {
    const n = Number(String(precioStr || "").replace(/[^0-9]/g, ""));
    return Number.isFinite(n) && n > 0;
}


// convierte un arreglo limpio de items, listo para guardarlo en la base de datos, como detalles: [String]
function limpiarLineasDetalles(texto) {
    return (texto || "") // Si texto viene null o undefined, usa string vacío para no romper.
    .split("\n") // toma las lineas y las converite en posiciones del arreglo, ej: 3 líneas, 3 posiciones en el arreglo.
    .map(l => l.trim()) // Quita espacios al inicio y al final de cada línea.
    .filter(Boolean) // Elimina líneas vacías.
    .map(l => 
        l.startsWith("-") // verifica si empieza con guion
        ? l.replace(/^[-\s]+/, "") // si si, quita el guión
        : l); 
}




export {
    contieneUrlTexto,
    contieneTelefono,
    contieneCorreo,
    validarNoContacto,
    precioValido,
    limpiarLineasDetalles
}